var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChevronLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 9,
    viewBox: "0 0 6 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "angle-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.74983 8.7496C4.65129 8.75007 4.55365 8.73085 4.46264 8.69307C4.37162 8.65529 4.28907 8.59972 4.21983 8.5296L0.719829 5.0296C0.579378 4.88898 0.500488 4.69835 0.500488 4.4996C0.500488 4.30085 0.579378 4.11023 0.719829 3.9696L4.21983 0.499603C4.36079 0.408212 4.52834 0.366791 4.69565 0.381978C4.86295 0.397166 5.02031 0.468083 5.14251 0.583362C5.2647 0.698641 5.34466 0.851607 5.36956 1.01774C5.39446 1.18388 5.36286 1.35357 5.27983 1.4996L2.27983 4.4996L5.27983 7.4996C5.42028 7.64023 5.49917 7.83085 5.49917 8.0296C5.49917 8.22835 5.42028 8.41898 5.27983 8.5596C5.1351 8.69029 4.94463 8.75858 4.74983 8.7496Z",
    fill: "#F8F9FA"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronLeft);
export default __webpack_public_path__ + "static/media/icon-chevron-left.c65cb826314350233900bf8e64bf6add.svg";
export { ForwardRef as ReactComponent };